<template>
	<div v-if="show" class="animated fadeIn">
		<el-container class="transfer-pannel">
			<el-header class="transfer-pannel__header" height="55px">
				<p>客服转接</p>
				<p class="tools">
					<i class="el-icon-close" @click="closeBox" />
				</p>
			</el-header>
			<el-main class="transfer-pannel__main">
				<div class="search">
					<label>快捷搜索：</label>
					<el-input size="mini" placeholder="搜索技能组" v-model="list_query.keyword" clearable 
					@keyup.enter.native="toSearch"></el-input>
					<el-button @click="toSearch" type="primary" size="mini" class="btn">查询</el-button>
				</div>
				<div class="lists">
					<table-pagination ref="table" pagination layout="prev,pager,next" :data="data" :column="column"  v-loading="loading"
						:total="total" :page.sync="list_query.pageNum" :limit.sync="list_query.pageSize" @pagination="getList" />
				</div>
			</el-main>
			<!-- 指定客服转接 -->
			<TransferItemPannel
				v-model="transferItemViewer.isShow"
				:source="transferItemViewer.source"
			/>

		</el-container>
	</div>
</template>
<script>
	import TransferItemPannel from './transferItem';
	import { isCanSend } from '@/utils/imService';
	import { mapState } from 'vuex';
	
	export default {
		computed:{
			...mapState({
				index_infos: state => state.imChatService.index_infos,
				userId:state => state.user.userInfo?.userId
			})
		},
		components:{
			TransferItemPannel
		},
		model: {
			prop: 'show',
			event: 'close',
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
		},
		watch:{
			show(){
				this.transferItemViewer = {
					isShow:false,
					source:null
					
				}
				this.getList();
			}
		},
		data() {
			return {
				transferItemViewer:{
					isShow:false,
					source:null
				},
				data:[],
				column:[{
					label: "品牌",
					prop: "childBrand"
				},{
					label: "技能组名称",
					prop: "skillName",
					width: 145
				},{
					label: "实时状态",
					prop: "freeCsrNum",
					render: (h, scope) => {
						return (
							<el-link underline={false} type={scope.row.freeCsrNum > 0 ? 'success' : 'danger'}>{scope.row.freeCsrNum > 0 ? '空闲' : '忙碌' }</el-link>
						);
					}
				},{
					label: "操作",
					prop: "action",
					align: "center",
					width: 120,
					render: (h, scope) => {
						return ( 
							<div style="cursor: pointer;">
							  <el-button type="text" onClick={() => this.toTransform(scope.row)}>
								转接
							  </el-button>
							  <br/>
							  <el-button type="text" onClick={() => this.handleTransformToCustomer(scope.row)}>
								指定客服转接
							  </el-button>
							</div>
						);
					}
				}],
				loading:false,
				total:0,
				list_query:{
					pageNum:1,
					pageSize:10,
					brand:'',
					keyword:'',
					sessionId:''
				}
			}
		},
		methods: {
			closeBox() {
				this.$emit('close', false)
			},
			// 转接技能组
			toTransform(source){
				this.$confirm("确认后将根据进线逻辑转接至该技能内空闲状态坐席","确认要直接转接至组内吗？", {
				    confirmButtonText: "确定",
				    cancelButtonText: "取消",
				    type: "warning",
				    center: true,
				    customClass: "confirm-element-model"
				  }
				).then(() => {
					  this.$api.transformImServiceToSkillGroup(`/livechat/forward/request/skillGroup/${this.index_infos.session_id}/${this.userId}/${source.childBrand}/${source.skillId}`)
					  .then(res => {
						  if(res.errcode != 0) return;
						   this.$message.success("转接成功");
					  })
		
					}).catch(() => {
					  this.$message.error("取消转接");
					})
			},
			handleTransformToCustomer(source){
				this.transferItemViewer.isShow = true;
				this.transferItemViewer.source = source;
				
			},
			toSearch(){
				this.list_query.pageNum = 1;
				this.getList();
			},
			getList(){
				this.loading = true;
				this.list_query.brand = this.index_infos.brand;
				this.list_query.sessionId = this.index_infos.session_id;
				this.$api.getImServiceTransformLists(this.list_query.brand,this.list_query).then(res => {
					this.loading = false;
					if(res.errcode != 0)  return;
					this.data = res.list;
					this.total = res.total;
					
				})
			}
			
		},
	}
</script>
<style lang="scss" scoped>
	.transfer-pannel {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		font-size: 12px;
		color: #3c4353;
		background-color: #fff;
		z-index: 99;
		&__header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #d8d8d8;
			font-size: 14px;
			font-weight: bold;
			.tools {
				font-size: 20px;
				cursor: pointer;
				
			}
		}
		&__main {
			height: calc(100% - 55px);
			overflow: hidden;
			.search {
				display: flex;
				align-items: center;
				label {
					width: 70px;
					display: inline-block;
					font-weight: 400;
					flex-shrink: 0;
				}
				.btn {
					width: 60px;
					margin-left: 10px;
					flex-shrink: 0;
				}
			}
			.lists {
				height: calc(100% - 100px);
				overflow: auto;
				margin: 20px 0;
				
			}
			
		}
		
	}
</style>
